import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import OnboardingPage from './pages/OnboardingPage';
import PurchasePage from './pages/PurchasePage';
import RedeemPage from './pages/RedeemPage';
import ClaimPage from './pages/ClaimPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import MentorshipPage from './pages/MentorshipPage';
import MentorshipSuccessPage from './pages/MentorshipSuccessPage';
import Dashboard from './pages/dashboard';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  
  // Wait for auth check to complete before redirecting
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: '#0f0f0f',
        color: 'white'
      }}>
        Loading...
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // Redirect to onboarding if not completed (unless already on onboarding)
  if (user && !user.onboarding_completed) {
    return <Navigate to="/onboarding" />;
  }
  
  return children;
};

const OnboardingRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  
  // Wait for auth check to complete
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: '#0f0f0f',
        color: 'white'
      }}>
        Loading...
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // If onboarding already completed, go to dashboard
  if (user && user.onboarding_completed) {
    return <Navigate to="/dashboard" />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/redeem" element={<RedeemPage />} />
            <Route path="/claim/:code" element={<ClaimPage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/purchase/:type/:id" element={<PurchasePage />} />
            <Route path="/mentorship/:planId" element={<MentorshipPage />} />
            <Route path="/mentorship/success" element={<MentorshipSuccessPage />} />
            <Route
              path="/onboarding"
              element={
                <OnboardingRoute>
                  <OnboardingPage />
                </OnboardingRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </AuthProvider>
  );
}

export default App;
